export const LOCAL_STORAGE_KEYS = {
  CURRENT_CAST_RELATIONSHIP_ID: 'currentCastRelationshipId'
} as const;
